import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Select } from 'antd';
import Input from '../../ui/Input';
import { getOTACodes } from '../../../services/common'
import { HOTEL_LOCATION, DISTANCE_UNIT, DIRECTIONS, YES_NO,ACCURACY } from '../constants'

import Loading from '../../Loading';
interface propsTypes {
    rowData: void | any,
    addLoading: void | any
}

const FormItem = Form.Item;
const Option = Select.Option;
const ReferenceEdit = (props: propsTypes | any) => {
    const [typeferencData, setTypeferencData] = useState<Array<any>>([])
    const [categoryData, setCategoryData] = useState<Array<any>>([])
    const [referencData, setreferencData] = useState<Array<any>>([])
    const [stateData, setStateData] = useState<Array<any>>([])
    const typeferData = async () => {
        let res = await getOTACodes('RET', '')
        if (res && res.otacodes && res.otacodes.length !== 0) {
            res.otacodes.map((item: any) => item.key = item.codeName)
            setTypeferencData(res.otacodes)
        } else {
            setTypeferencData([])
        }
    };
    const categoData = async () => {
        let res = await getOTACodes('ACC', '')
        if (res && res.otacodes && res.otacodes.length !== 0) {
            res.otacodes.map((item: any) => item.key = item.codeName)
            setCategoryData(res.otacodes)
        } else {
            setCategoryData([])
        }
    };
    const staData = async () => {
        let res = await getOTACodes('USA', '')
        if (res && res.otacodes && res.otacodes.length !== 0) {
            res.otacodes.map((item: any) => item.key = item.codeName)
            setStateData(res.otacodes)
        } else {
            setStateData([])
        }
    };
    const referData = async () => {
        let res = await getOTACodes('COU', '')
        if (res && res.otacodes && res.otacodes.length !== 0) {
            res.otacodes.map((item: any) => item.key = item.codeName)
            setreferencData(res.otacodes)
        } else {
            setreferencData([])
        }
    };
    useEffect(() => {
        typeferData()
        categoData()
        referData()
        staData()
    }, [])
    return (props.addLoading ? <Loading type="large" /> :
        <div style={{ paddingLeft: 16 }}>
            <Row gutter={24} className="row-margin">
                <Col span={6} >
                    <Form.Item name="name" label="Name" rules={[{ required: true, message: 'This field is required' },
                    { max: 75, message: 'You have reached the max character length of 75' }]}>
                        <Input maxLength={75} />
                    </Form.Item>
                </Col>
                <Col span={6} >
                    <Form.Item name="id" label="ID" rules={[{ max: 50, message: 'You have reached the max character length of 50' }]}>
                        <Input maxLength={50} />
                    </Form.Item>
                </Col>

            </Row>
            <Row gutter={24} className="row-margin">
                <Col span={12} >
                    <Form.Item
                        extra={<span className="blue-font">Directions By This Transportation</span>}
                        name="directiondescription" label="Direction/Description" rules={[{ max: 2000, message: 'You have reached the max character length of 2000' }]}>
                        <Input maxLength={2000} />
                    </Form.Item>

                </Col>
            </Row>
            <Row gutter={24} className="row-margin">
                <Col span={6} >
                    <Form.Item name="type" label="Type" rules={[{ required: true, message: 'This field is required' }]}>
                        <Select allowClear showSearch>
                            {typeferencData && typeferencData.length ? typeferencData.map((item) => {
                                return (
                                    <Select.Option value={item.codeName} key={item.codeName} showSearch>{item.codeName}</Select.Option>
                                )
                            }) : null}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={6} >
                    <Form.Item name="airportcode" label="3 Character Airport Code" rules={[{ max: 3, message: 'You have reached the max character length of 3' }]}>
                        <Input maxLength={3} />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24} className="row-margin">
                <Col span={12} >
                    <Form.Item
                        extra={<span className="blue-font">Additional Details Of This Transportation</span>}
                        name="typedetail" label="Type Detail" rules={[{ max: 2000, message: 'You have reached the max character length of 2000' }]}>
                        <Input maxLength={2000} />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24} className="row-margin">
                <Col span={6} >
                    <Form.Item name="category" label="Category" rules={[{ required: true, message: 'This field is required' }]}>
                        <Select allowClear showSearch>
                            {categoryData && categoryData.length ? categoryData.map((item) => {
                                return (
                                    <Select.Option value={item.codeName} key={item.codeName} showSearch>{item.codeName}</Select.Option>
                                )
                            }) : null}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={6} >
                    <Form.Item name="distance" label="Distance" rules={[{ required: true, pattern: /^\d*(\.\d*)?$/, message: 'This field should be a number' }]} >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={6} >
                    <Form.Item name="distanceunit" label="Distance Unit" rules={[{ required: true, message: 'This field is required' }]}>
                        <Select allowClear showSearch>
                        {DISTANCE_UNIT.map((item: string) => {
                                    return <Option value={item}>{item}</Option>
                                })}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24} className="row-margin">
                <Col span={6} >
                    <Form.Item name="direction" label="Direction" >
                        <Select allowClear showSearch>
                        {DIRECTIONS.map((item: string) => {
                                    return <Option value={item}>{item}</Option>
                                })}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={6} >
                    <Form.Item name="toorfrom" label="To or From" rules={[{ required: true, message: 'This field is required' }]}>
                        <Select allowClear showSearch>
                            <Option value="To Facility">To Facility</Option>
                            <Option value="From Facility">From Facility</Option>
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={6} >
                    <Form.Item name="isnearest" label="Is Nearest" >
                        <Select allowClear showSearch>
                        {YES_NO.map((item: string) => {
                                    return <Option value={item === 'Yes' ? 'true' : 'false'}>{item}</Option>
                                })}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24} className="row-margin">
                <Col span={6} >
                    <Form.Item name="isprimary" label="Is Primary" >
                        <Select allowClear showSearch>
                        {YES_NO.map((item: string) => {
                                    return <Option value={item === 'Yes' ? 'true' : 'false'}>{item}</Option>
                                })}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={6} >
                    <Form.Item
                        extra={<span className="blue-font">Range from -90.000 000 to 90.000 000</span>}
                        name="latitude" label="Latitude" rules={[{ pattern: /^[+-]?(([1-8]?[0-9])(\.[0-9]{1,6})?|90(\.0{1,6})?)$/, message: 'This field should be a valid number' }]}>
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={6} >
                    <Form.Item
                        extra={<span className="blue-font">Range from -180.000 000 to 180.000 000</span>}
                        name="longitude" label="Longitude" rules={[{ pattern: /^[+-]?((([1-9]?[0-9]|1[0-7][0-9])(\.[0-9]{1,6})?)|180(\.0{1,6})?)$/, message: 'This field should be a valid number' }]}>
                        <Input />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24} className="row-margin">
                <Col span={6} >
                    <Form.Item name="accuracy" label="Geocode Accuracy" >
                        <Select allowClear showSearch>
                        {ACCURACY.map((item:string)=>{
                                   return <Option value={item}>{item}</Option>
                                })}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={6} >
                    <Form.Item name="country" label="Country" >
                        <Select allowClear showSearch>
                            {referencData && referencData.length ? referencData.map((item) => {
                                return (
                                    <Select.Option value={item.codeName} key={item.codeName}>{item.codeName}</Select.Option>
                                )
                            }) : null}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={6} >
                    <Form.Item name="state" label="State">
                        <Select allowClear showSearch>
                            {stateData && stateData.length ? stateData.map((item) => {
                                return (
                                    <Select.Option value={item.codeName} key={item.codeName}
                                    showSearch>{item.codeName}</Select.Option>
                                )
                            }) : null}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24} className="row-margin">
                <Col span={6} >
                    <FormItem
                        extra={<span className="blue-font">Please input Rank as 1, 2, 3, etc... for each Reference Point, especially for Airport</span>}
                        name="rank" label="Rank" rules={[{ pattern: /^\+?[0-9]\d*$/, message: 'This field should be a number' },

                        ]}>
                        <Input />
                    </FormItem>
                </Col>
                <Col span={6} >
                        <FormItem name="hotellocation" label="Hotel Location" >
                            <Select allowClear showSearch>
                                {HOTEL_LOCATION.map((item: string) => {
                                    return (
                                        <Option value={item}>{item}</Option>
                                    )
                                })}
                            </Select>
                        </FormItem>
                    </Col>
                <Col span={6} style={{ display: 'none' }}>
                    <FormItem name='refpointid' label="Start Date">
                        <Input />
                    </FormItem>
                </Col>
                <Col span={6} style={{ display: 'none' }}>
                    <FormItem name='refpointlangid' label="Start Date">
                        <Input />
                    </FormItem>

                </Col>
            </Row>
        </div>
    )
}

export default ReferenceEdit;

